import { inject, Injectable } from '@angular/core'
import { firstValueFrom, Observable } from 'rxjs'
import { ParticipantService, RegistrationsService, SessionService } from 'superlikers-microsites-api'

import { adapterUser } from '@core/adapters/user.adapters'
import { Participant } from '@core/interfaces/users.interface'

@Injectable({
  providedIn: 'root'
})
export class UserService {
  participantService = inject(ParticipantService)
  sessionService = inject(SessionService)
  registrationService = inject(RegistrationsService)

  async getUser() {
    const response = await firstValueFrom(this.participantService.getParticipant<Participant>())
    if (!response.participation.authenticated) {
      return null
    }

    const user = adapterUser(response.participation)
    return user
  }

  async getUserRanking() {
    const response$ = this.participantService.getRank()
    const response = await firstValueFrom(response$)
    return response.data.ranking
  }

  async updateAvatar(avatar: string) {
    const response$ = this.registrationService.updateParticipant({ avatar })
    const response = await firstValueFrom(response$)
    return response
  }

  async updateUser(data: Record<string, unknown>) {
    const response$ = this.registrationService.updateParticipant(data)
    const response = await firstValueFrom(response$)
    return response
  }

  checkRequirements(): Observable<{ allowed: boolean; redirect_page: string }> {
    return this.sessionService.checkRequirements()
  }
}
